import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAB-AOuXO-Hnj3-obDJHDMe9hgYLoZk3Fs",
  authDomain: "vision-919f6.firebaseapp.com",
  projectId: "vision-919f6",
  storageBucket: "vision-919f6.firebasestorage.app",
  messagingSenderId: "649936397163",
  appId: "1:649936397163:web:88d75118d997ed2b1aa22e",
  measurementId: "G-Z443QGGNBW",
};

const VAPID_KEY =
  "BMbgoTv_zck7B8D6dfdmEYnr8oOTslFvALBgeczdVWz7wz3om2mauHcbzjDihkyEXlXYOlJFSgO9kp3pu9OGCGI";

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

/**
 * Request notification permission and get FCM token
 * @returns {Promise<string|null>} FCM token or null if permission denied
 */
export const requestNotificationPermission = async () => {
  try {
    console.log("Requesting notification permission...");
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      console.log("Permission granted. Getting FCM token...");
      const currentToken = await getToken(messaging, {
        vapidKey: VAPID_KEY,
      });

      if (currentToken) {
        console.log("FCM Token:", currentToken);
        return currentToken;
      } else {
        console.warn("No registration token available. Request permission to generate one.");
        return null;
      }
    } else {
      console.warn("Notification permission not granted.");
      return null;
    }
  } catch (error) {
    console.error("An error occurred while retrieving token:", error);
    return null;
  }
};

/**
 * Set up foreground message listener
 * @param {Function} callback - Callback function to handle incoming messages
 */
export const setupMessageListener = (callback) => {
  onMessage(messaging, (payload) => {
    console.log("Message received in foreground:", payload);

    // Show browser notification
    if (payload.notification) {
      new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: payload.notification.icon || "/favicon.png",
      });
    }

    // Call custom callback if provided
    if (callback && typeof callback === "function") {
      callback(payload);
    }
  });
};

export { messaging };
